import { apiFetch } from './client';

const METRICS_BASE = '/klaviyo-metrics';
const PROFILE_PROPERTIES_BASE = '/klaviyo-profile-properties';

/**
 * List the Klaviyo metrics (events) the tenant's Klaviyo account has
 * reported, as `[{id, name}]`. Seeds the event-mapping drawer's EMIT_EVENT
 * action-name field -- a suggestion list, not an enum, since a client may
 * legitimately emit an event Klaviyo has not seen yet (ch60572).
 */
export const getMetrics = ({ signal } = {}) => apiFetch(METRICS_BASE, { signal });

/**
 * List the property keys Klaviyo has seen on a given metric's events, as
 * `[string]`. Sampled, not authoritative -- can come back `[]` (the upstream
 * call needs API revision 2026-07-15 and the metrics:read scope; when either
 * is missing the backend returns an empty list rather than an error), so
 * callers must fall back to free text rather than rendering an empty
 * dropdown (ch60572).
 */
export const getMetricProperties = (metricId, { signal } = {}) =>
  apiFetch(`${METRICS_BASE}/${metricId}/properties`, { signal });

/**
 * Sample of Klaviyo profile property names, as `[string]`. Klaviyo has no
 * endpoint enumerating custom profile properties -- they're per-profile
 * values, not an account schema -- so this is a bounded sample unioned with
 * Klaviyo's documented standard properties, and can never be complete; free
 * text must always remain possible alongside it (ch60572).
 */
export const getProfileProperties = ({ signal } = {}) => apiFetch(PROFILE_PROPERTIES_BASE, { signal });
